import { RouteObject } from 'react-router-dom';
import Logout from 'src/auth/Logout';

export const getGeneralRoutes = (): RouteObject[] => [{
  path: 'logout',
  element: (<Logout />)
}];
